import { ReplaySubject } from "rxjs"

// Custom auth events specific to selfhost enterprise
export type EnterpriseAuthEvent = { type: "user_deactivated" }

export const enterpriseAuthEvents$ = new ReplaySubject<EnterpriseAuthEvent>(1)
